class Testimonials extends HTMLElement {
  constructor() {
    super();

    this.initSlideshowSlick();
  }

  initSlideshowSlick(){
    const slideshow = this.querySelector('.testimonials-slider ');

    var star_uls = $(slideshow).find('.card ul');
    $( star_uls ).each(function( index, value ) {
      var number_of_stars_to_light = $( this ).data('stars');
      var number_of_stars = $( this ).children().slice(0,number_of_stars_to_light);
      $( number_of_stars ).each(function( index2, value2 ) {
        $(this).find('i').css('color', '#FEC62E')
      });
    });

    var settings_slider = {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 4000,
      vertical: false,
      cssEase: 'ease-out',
      responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 799,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
    };

    $(slideshow).slick(settings_slider);


  }
}

customElements.define('testimonials-section', Testimonials);
